export enum FulfillmentMethod {
  Delivery = 'Delivery',
  Pickup = 'Pickup',
}
